import React from "react";
import { Container } from "reactstrap";

import useWarnings from "./hooks/useWarnings";
import WarningBanner from "./WarningBanner";

const WarningsList = () => {
  const {
    warnings,
    // isLoading
  } = useWarnings();

  if (!warnings?.length) return null;
  return (
    <Container fluid className="w-100 mb-2 d-flex flex-column" style={{ gap: ".5rem" }}>
      {warnings.map((warning, i) => (
        <WarningBanner
          key={i}
          title={warning.title}
          text={warning.message}
          type={warning.type === "error" || warning.type === "critical" ? "danger" : warning.type}
        />
      ))}
    </Container>
  );
};

export default WarningsList;
